export default __webpack_public_path__ + "img/76b5a8d89eea26c7af05d8de2f8da6ae.svg";